import React, { Component, Suspense, useEffect } from 'react'
import {
    Route,
    Switch,
    Redirect,
    BrowserRouter,
    useLocation,
} from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as Actions from './firebase-redux/actions/index.js'
import Loader from './components/loader/Loader.jsx'
import BottomMobileMenu from './components/bottomMobileMenu/BottomMobileMenu.jsx'
import Header from './components/header/Header.jsx'
import Footer from './components/footer/Footer.jsx'
import ErrorBoundary from './components/errorBoundary/ErrorBoundary.jsx'
import { routes } from './imports/config.js'
import { registerLocale } from 'react-datepicker'
import it from 'date-fns/locale/it'
import { withTranslation } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import CookieBanner from './components/cookieBanner/CookieBanner'
import 'react-toastify/dist/ReactToastify.css'

const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}

const CustomRoute = ({
    component: Component,
    authed,
    redirect,
    componentProps,
}) => (
    <Route
        render={props =>
            authed === true && Component ? (
                <>
                    <ScrollToTop />
                    <Component {...props} />
                </>
            ) : (
                <Redirect
                    to={{
                        pathname: redirect,
                        state: { from: props.location },
                    }}
                />
            )
        }
    />
)

class App extends Component {
    componentDidMount() {
        const env = process.env.REACT_APP_ENV
        if (env === 'BETA') {
            console.log('Analytics Tag Beta Appended')

            let script = document.createElement('script')
            script.text =
                "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WQ5TMRN');"
            document.head.appendChild(script)

            let noScript = document.createElement('noscript')
            noScript.id = 'analyticsTag'
            document.body.appendChild(noScript)

            let iframe = document.createElement('iframe')
            iframe.src =
                'https://www.googletagmanager.com/ns.html?id=GTM-WQ5TMRN'
            iframe.height = 0
            iframe.width = 0
            iframe.style = 'display:none;visibility:hidden'
            document.getElementById('analyticsTag').appendChild(iframe)
        }

        registerLocale('it', it) //Register localization for React DatePicker
    }

    componentDidUpdate(prevProps) {
        if (
            !prevProps.checkAuthDone &&
            this.props.checkAuthDone === true &&
            (!this.props.user?.role || this.props.user?.role === 'coworker')
        ) {
            this.props.loadCoworkings()
        }
    }

    render() {
        if (this.props.checkAuthDone) {
            return (
                <ErrorBoundary>
                    <BrowserRouter>
                        <div className='full-container'>
                            <ToastContainer
                                position='top-center'
                                autoClose={3200}
                                hideProgressBar
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable={false}
                                pauseOnHover
                            />
                            <CookieBanner />
                            <Header
                                user={this.props.user}
                                signOut={this.props.signOut}
                                updateWishlist={newWishlistItem =>
                                    this.props.updateProfile(
                                        this.props.user.uid,
                                        {
                                            wishlist: newWishlistItem,
                                        }
                                    )
                                }
                                updateOptions={this.props.updateOptions}
                            />
                            <Suspense
                                fallback={
                                    <div className='page-container'>
                                        <Loader />
                                    </div>
                                }
                            >
                                <Switch>
                                    {routes.map((route, i) => {
                                        return (
                                            <CustomRoute
                                                key={i}
                                                exact
                                                path={route.path}
                                                authed={
                                                    route.visibility === 'all'
                                                        ? true
                                                        : (this.props.user
                                                              ?.role &&
                                                              route.visibility ===
                                                                  'logged') ||
                                                          (!this.props.user
                                                              ?.role &&
                                                              route.visibility ===
                                                                  'unlogged')
                                                        ? true
                                                        : false
                                                }
                                                redirect={route.redirect}
                                                component={
                                                    route.ownerComponent &&
                                                    this.props.user?.role ===
                                                        'owner'
                                                        ? route.ownerComponent
                                                        : route.coworkerComponent &&
                                                          this.props.user
                                                              ?.role ===
                                                              'coworker'
                                                        ? route.coworkerComponent
                                                        : route.component
                                                }
                                            />
                                        )
                                    })}
                                </Switch>
                            </Suspense>
                            <Footer />
                            <BottomMobileMenu user={this.props.user} />
                        </div>
                    </BrowserRouter>
                </ErrorBoundary>
            )
        } else {
            return <Loader />
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Actions, dispatch)
}

export default withTranslation()(
    connect(state => {
        return {
            checkAuthDone: state.user.checkAuthDone,
            user: state.user.profile,
            userLoading: state.user.loading,
            userError: state.user.error,
            userNotificationText: state.user.notificationText,
            coworkings: state.coworking,
        }
    }, mapDispatchToProps)(App)
)
